import React from 'react';
import { Dialog, Button, Group } from '@economic/taco';
import Icon from '../../../../../shared/components/ui/primitives/Icon';
import { t } from '../../../../../shared/components/l10n/l10n';
import { Field } from '../../../../../shared/components/Form';
import { SendByType } from './types';

interface Props {
    onBack: () => void;
    onOk: () => void;
    text: string;
}

export function BookOnlyConfirmationDialogContent({ onBack, onOk, text }: Props) {
    return (
        <div className="h-full flex flex-col">
            <Dialog.Title>
                <Icon name="warning" className="text-xl" aria-label="Confirmation" />
            </Dialog.Title>

            <div className="flex-grow">
                <p className="font-bold text-center">{text}</p>
                <Field.Checkbox name="skipBookOnlyConfirmation" text={t`FORM_BOOKANDSEND_BOOK_ONLY_CONFIRMATION_DO_NOT_SHOW`} />
                <Field.Hidden name="sendByType" value={SendByType.undefined} />
            </div>

            <Dialog.Footer>
                <Group>
                    <Button onClick={onBack}>{t`FORM_BOOKANDSEND_BACK`}</Button>
                    <Button appearance="primary" type="submit" onClick={onOk}>{t`FORM_BOOKANDSEND_BOOK_TEXT`}</Button>
                </Group>
            </Dialog.Footer>
        </div>
    );
}
